import React, {Fragment} from 'react';
import {Text, View, StyleSheet } from '@react-pdf/renderer';
import { formatMoney } from '@iso/lib/helpers/utility';

const styles = StyleSheet.create({
    fragmentContainer: {
        marginTop: '15px',
        width: '100%',
        flexDirection: 'row',
        height: 70,
        border: '1px solid #000000',
        borderRadius:'3px'
    },
    columnContainer: {
        borderLeft: '1px solid #000000',
        justifyContent: 'center',
        padding: '2px',
        width: '60%'
    },
    label: {
        textAlign: 'center',
        fontSize: 12,
        fontWeight: 'bold'
    },
    content: {
        fontSize: 12
    },
    dateContainer: {
        justifyContent: 'center',
        alignItems: 'center',
        width: '20%'
    },
    dataContainer: {
        justifyContent: 'center',
        alignItems: 'center',
        borderLeft: '1px solid #000000',
        width: '20%'
    },
    dateData: {
        fontSize: 12,
        fontStyle: 'bold'
    },
    date: {
        fontSize: 10,
        fontStyle: 'bold'
    }
});

const ProposalSignature = ({ invoice }) => {
  let totalValue = 0;

  invoice.items.forEach((item) => {
      if( typeof item.item._id !== 'undefined') {
          totalValue += item.quantity * item.unit_price - item.quantity * item.discount;
      }
  });

  const formattedTotalValue = formatMoney(totalValue+'');
  
    return (
      <Fragment>
        <View key={"container"} style={styles.fragmentContainer}>
          <View key={"collumDate"} style={styles.dateContainer}>
            <Text style={styles.date}>Data de aprovação </Text>
            <Text style={styles.dateData}>__/ __/ ____</Text>
          </View>
          <View key={"collum"} style={styles.columnContainer}>
            <Text key={"company"} style={styles.label}>
              Assinatura do cliente
            </Text>
            <Text style={styles.label}>______________________________________</Text>
          </View>
          <View key={"collumData"} style={styles.dataContainer}>
            <Text style={styles.date}>Proposta n°: {invoice.invoice_no}</Text>
            <Text style={styles.date}> R$ {formattedTotalValue} </Text>
          </View>
        </View>
      </Fragment>
    );
  };
    
    export default ProposalSignature